export const DATE_FORMATS = {
  CALENDAR: 'dd/MM/yyyy',
  CALENDAR_WITH_TIME: 'dd/MM/yyyy h:mm a',
  SHORT_YEAR: 'dd/MM/yy',
  MONTH_NAME: 'MMMM dd, yyyy',
  MONTH_NAME_DAY_SUFFIX: 'MMMM do yyyy'
}
